import { useEffect } from 'react';
export const useTextBlockSelectionChange = (containerRef) => {
    useEffect(() => {
        const handleSelectionChange = () => {
            var _a;
            const selection = window.getSelection();
            if (!selection || selection.rangeCount === 0)
                return;
            const range = selection.getRangeAt(0);
            const selectedElements = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[contenteditable="false"]');
            selectedElements === null || selectedElements === void 0 ? void 0 : selectedElements.forEach((el) => {
                const elementRange = document.createRange();
                elementRange.selectNodeContents(el);
                const isFullySelected = range.compareBoundaryPoints(Range.START_TO_START, elementRange) <= 0 &&
                    range.compareBoundaryPoints(Range.END_TO_END, elementRange) >= 0;
                if (isFullySelected) {
                    el.setAttribute('data-selected', 'true');
                }
                else {
                    el.setAttribute('data-selected', 'false');
                }
            });
        };
        document.addEventListener('selectionchange', handleSelectionChange);
        return () => document.removeEventListener('selectionchange', handleSelectionChange);
    }, []);
};
